import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsAuthenticationCredentialDeleteCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/authentication_credentials",
];
